// extracted by css-extract-rspack-plugin
export default {"image":"BlockingConfirmModal_image__r00Te","container":"BlockingConfirmModal_container__HJcBt"};